import React from "react";
import { connect } from "react-redux";
import FilmalityCircularProgress from "../../../../shared/filmality-circular-progress";
import Prop from "./prop";

import confirm from "../../../../shared/modal/confirm";
import {
  OnboardingStep1ClassName,
  OnboardingStep2ClassName,
  OnboardingStep3ClassName,
  OnboardingStep4ClassName
} from "./ducks/reducer";
import Onboarding from '../../../../shared/onboarding/onboarding';
import Download from "../../../../shared/download";
import Errors from "../../../../shared/errors";
import FilmanizeCheckbox from "../../../../shared/filmanize-checkbox";

function Overview(props) {
  const {
    overview,
    filmId,
    errors,
    warnings,
    characterOrderBy,
    onboardingSteps,
    progress,
    download,
    clearPdf,
    onDownloadFile,
    aliasProp,
    unaliasProp,
    readOnly,
    propsAcquiredPercentage,
    processingPropIds,
    deleteMultipleProps
  } = props;

  const [selectedPropIds, setSelectedPropIds] = React.useState<number[]>([]);

  const togglePropSelection = (propId: number) => {
    setSelectedPropIds(prev =>
      prev.includes(propId)
        ? prev.filter(id => id !== propId)
        : [...prev, propId]
    );
  };

  const toggleSelectAll = () => {
    if (selectedPropIds.length === overview.props?.length) {
      setSelectedPropIds([]);
    } else {
      setSelectedPropIds(overview.props?.map(p => p.id) || []);
    }
  };

  const deleteMultiplePropsLocal = (filmId, selectedPropIds) => {
    deleteMultipleProps(filmId, selectedPropIds)
    setSelectedPropIds([]);
  }

  const handleDeleteSelected = () => {
    if (selectedPropIds.length === 0) return;
    confirm(() => deleteMultiplePropsLocal(filmId, selectedPropIds), null, `Are you sure you want to delete ${selectedPropIds.length} prop${selectedPropIds.length !== 1 ? 's' : ''}?`, "Delete Props");
  };


  function PropsList() {
    const allSelected = selectedPropIds.length === overview.props?.length && overview.props?.length > 0;

    return (
      <>
        <table className={`${OnboardingStep3ClassName} table`}>
          <thead>
            <tr>
              {!readOnly && (
                <th>
                  <FilmanizeCheckbox
                    checked={allSelected}
                    onChange={toggleSelectAll}
                  />
                </th>
              )}
              <th>Name</th>
              <th>Quantity</th>
              <th>Quantity Acquired</th>
              <th>Acquisition Method</th>
            </tr>
          </thead>
          <tbody>
            {(overview.props || []).map((prop, index) => {
              return (
                <Prop
                  key={index}
                  index={index}
                  prop={prop}
                  filmId={filmId}
                  readOnly={readOnly}
                  aliasProp={aliasProp}
                  unaliasProp={unaliasProp}
                  processingPropIds={processingPropIds}
                  isSelected={selectedPropIds.includes(prop.id)}
                  onToggleSelect={() => togglePropSelection(prop.id)} />
              );
            })}
          </tbody>
        </table>
      </>
    );
  }


  return (
    <div>
      <div className="columns">
        <div
          className={`${OnboardingStep1ClassName} circular-progress column`}>
          <FilmalityCircularProgress
            percentage={propsAcquiredPercentage}
            title="Props Acquired"
          />
        </div>
      </div>
      {errors && <Errors errors={errors} />}
      {warnings && <Errors errors={warnings} isWarning={true} />}
      <div className={OnboardingStep2ClassName}>
        <div className="columns">
          <div className="column">
            <PropsList />
          </div>
        </div>
      </div>
      <div className="mt-1 buttons">
        <Download
          progress={progress}
          clearPdf={clearPdf}
          download={download}
          downloadFile={onDownloadFile} />

        {!readOnly && overview.props?.length > 0 && (
          <button
            className="button is-danger"
            onClick={handleDeleteSelected}
            disabled={selectedPropIds.length === 0}
          >
            Delete Selected ({selectedPropIds.length})
          </button>

        )}
      </div>
      <Onboarding onboardingSteps={onboardingSteps} section="Props Overview" />
    </div>
  );
}

export default Overview;
